import { ESuggestionsActionTypes } from '../../actions/suggestions';
import { DEFAULT_SUGGESTIONS_STATE } from '../../constants/redux';
import { mapSuggestions } from '../../mappers/suggestions';
import { TReduxActions } from '../../types/redux';
import { ISuggestionsState } from '../../types/redux/suggestions';

export function suggestionsReducer(state: ISuggestionsState = DEFAULT_SUGGESTIONS_STATE, action: TReduxActions) {
  switch (action.type) {
    case ESuggestionsActionTypes.Request: {
      return {
        loading: true,
        list: null,
      };
    }
    case ESuggestionsActionTypes.Success:
      return {
        loading: false,
        list: mapSuggestions(action.payload),
      };
    case ESuggestionsActionTypes.Failure:
    case ESuggestionsActionTypes.Reset:
      return {
        loading: false,
        list: null,
      };
    default:
      return state;
  }
}
